import { React, FelaComponent, Icon } from '../dependencies';

const noMenuRule = () => {
    const fontSize = 20;
    return {
        fontSize: `${fontSize}px`,
        fontWeight: 'bold',
        textAlign: 'center',

        '& .anticon-frown': {
            fontSize: `${fontSize * 2}px`,
        },
    };
};

const NoMenuMessage = () => (
    <FelaComponent
        rule={noMenuRule}
        render={({ className }) => (
            <div className={className}>
                Menu není bohužel k dispozici
                <br />
                <Icon type="frown" />
            </div>
        )}
    />
);

export default NoMenuMessage;
